import type { ConversationMessage } from "@/stores/conversation-store";
import { FLOATING_INITIAL_MESSAGES } from "./use-floating-conversation-messages";
import type { FocusWindowBox } from "@/lib/focus-window-layout";
import { beginFloatingFrameDrag } from "./floating-frame-drag";
import { getWindowDisplayId } from "./use-window-role";
import { getWindowOrigin } from "./use-window-origin";
import type { FrameData } from "@/lib/frame-data";

export function beginDetachedChatTransfer({
  data,
  projectId,
  spaceId,
  box,
  event,
  onTransfer,
  messages,
}: {
  data: FrameData;
  projectId: string | undefined;
  spaceId: string | undefined;
  box: FocusWindowBox;
  event: { clientX: number; clientY: number };
  onTransfer: () => void;
  messages?: ConversationMessage[];
}) {
  const displayId = getWindowDisplayId();
  if (displayId === null || !projectId || !spaceId) return;
  const origin = getWindowOrigin();
  const globalBox = { ...box, x: box.x + origin.x, y: box.y + origin.y };
  beginFloatingFrameDrag(
    {
      frameId: data.frameId,
      frame: messages?.length
        ? {
            ...data,
            content: { ...data.content, [FLOATING_INITIAL_MESSAGES]: messages },
          }
        : data,
      projectId,
      spaceId,
      displayId,
      sourceDisplayId: displayId,
      box: globalBox,
      normalBox: globalBox,
      mode: "normal",
      dragging: true,
    },
    event,
    { waitForCrossing: true, onTransfer },
  );
}
